<template>
	<div class="map-controls">
		<div class="map-filter-box">
			<button
				class="map-filter-box__toggle"
				:class="filterOpen ? 'is-open' : 'is-closed'"
				type="button"
				@click="filterOpen = !filterOpen"
			>
				{{ labels.filters }}
				<svg class="icon icon-chevron">
					<use xlink:href="#icon-chevron"></use>
				</svg>
			</button>

			<div class="map-filter-box__filters" v-if="filterOpen">
				<div class="map-filter-group">
					<button
						type="button"
						class="map-filter-group__toggle"
						:class="amenitiesOpen ? 'is-open' : 'is-closed'"
						@click="amenitiesOpen = !amenitiesOpen"
					>
						{{ labels.amenities }}
						<svg class="icon icon-chevron">
							<use xlink:href="#icon-chevron"></use>
						</svg>
					</button>

					<div class="map-filter-group__content" v-if="amenitiesOpen">
						<div class="map-filters">
							<!-- <div class="map-filter">
								<input type="checkbox" v-model="amenities" id="ccs" value="ccs" />
								<label for="ccs" class="map-filter">
									<svg class="icon icon-ccs">
										<use xlink:href="#icon-ccs"></use>
									</svg>
									{{ labels.ccs_charging }}
								</label>
							</div> -->
							<div class="map-filter">
								<input type="checkbox" v-model="amenities" id="mcs" value="mcs" />
								<label for="mcs" class="map-filter">
									<svg class="icon icon-mcs">
										<use xlink:href="#icon-mcs"></use>
									</svg>
									{{ labels.mcs_charging }}
								</label>
							</div>
							<div class="map-filter">
								<input type="checkbox" v-model="amenities" id="secure" value="secure" />
								<label for="secure" class="map-filter">
									<svg class="icon icon-secure-parking">
										<use xlink:href="#icon-secure-parking"></use>
									</svg>
									{{ labels.secure_parking }}
								</label>
							</div>
							<div class="map-filter">
								<input type="checkbox" v-model="amenities" id="restaurant" value="restaurant" />
								<label for="restaurant" class="map-filter">
									<svg class="icon icon-restaurant">
										<use xlink:href="#icon-restaurant"></use>
									</svg>
									{{ labels.restaurant }}
								</label>
							</div>
							<div class="map-filter">
								<input
									type="checkbox"
									v-model="amenities"
									id="vending_machine"
									value="vending_machine"
								/>
								<label for="vending_machine" class="map-filter">
									<svg class="icon icon-vending-machine">
										<use xlink:href="#icon-vending-machine"></use>
									</svg>
									{{ labels.vending_machine }}
								</label>
							</div>
							<div class="map-filter">
								<input type="checkbox" v-model="amenities" id="toilet" value="toilet" />
								<label for="toilet" class="map-filter">
									<svg class="icon icon-toilet">
										<use xlink:href="#icon-toilet"></use>
									</svg>
									{{ labels.toilet }}
								</label>
							</div>
							<div class="map-filter">
								<input type="checkbox" v-model="amenities" id="shower" value="shower" />
								<label for="shower" class="map-filter">
									<svg class="icon icon-shower">
										<use xlink:href="#icon-shower"></use>
									</svg>
									{{ labels.shower }}
								</label>
							</div>
							<div class="map-filter">
								<input type="checkbox" v-model="amenities" id="lounge" value="lounge" />
								<label for="lounge" class="map-filter">
									<svg class="icon icon-lounge">
										<use xlink:href="#icon-lounge"></use>
									</svg>
									{{ labels.lounge }}
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="map-filter-group" v-if="useRoutes && routeDataLoaded">
					<button
						type="button"
						class="map-filter-group__toggle"
						:class="routesOpen ? 'is-open' : 'is-closed'"
						@click="routesOpen = !routesOpen"
					>
						{{ labels.tent_corridors }}
						<svg class="icon icon-chevron">
							<use xlink:href="#icon-chevron"></use>
						</svg>
					</button>

					<div class="map-filter-group__content" v-if="routesOpen">
						<div class="map-filters">
							<div class="map-filter" v-for="route in routeData">
								<input
									type="checkbox"
									:id="route.id"
									:value="route.id"
									@input="updateActiveRoutes($event)"
									:checked="activeRoutes.includes(route.id)"
								/>
								<label :for="route.id" class="map-filter">{{ route.name }}</label>
							</div>

							<div class="map-filter">
								<button
									type="button"
									class="map-filter-button"
									:class="activeRoutes.length == routeData.length ? 'active' : ''"
									@click="handleRoutesToggle"
								>
									{{ labels.show_all }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			:class="selectedMarker ? 'map-controls__wrapper map-controls__wrapper--slideOut' : 'map-controls__wrapper'"
		>
			<slot></slot>

			<MapboxGeocoder
				access-token="pk.eyJ1IjoiYmVudG9kYXkiLCJhIjoiY2xlNzh4Y3lhMDM1bzN1bWdrYTFmMWN5bCJ9.fvgJSulDCj8AeuQ-pb8CYg"
				:marker="false"
				:zoom="7"
				:placeholder="labels.find"
				:flyTo="{ zoom: 8 }"
				v-if="!fullScreen"
			/>
		</div>
	</div>
</template>

<script>
import { MapboxGeocoder } from '@studiometa/vue-mapbox-gl';
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css';
export default {
	components: {
		MapboxGeocoder,
	},
	props: ['selectedMarker', 'labels', 'useRoutes', 'routeDataLoaded', 'activeRoutes', 'routeData', 'fullScreen'],
	emits: ['update:activeRoutes', 'filter', 'selectedMarker'],
	data() {
		return {
			amenities: [],
			filterOpen: false,
			amenitiesOpen: false,
			routesOpen: false,
		};
	},
	watch: {
		amenities(amenities) {
			this.$emit('filter', amenities);
		},
		selectedMarker(value) {
			if (value) {
				this.filterOpen = false;
			}
		},
		filterOpen(value) {
			if (value) {
				this.$emit('selectedMarker', null);
			}
		},
	},
	methods: {
		geocoder(instance) {
			console.log(instance);
		},
		updateActiveRoutes(event) {
			const value = event.target.value;
			let updatedValue = [...this.activeRoutes];

			if (event.target.checked) {
				updatedValue.push(value);
			} else {
				updatedValue = updatedValue.filter((v) => v !== value);
			}

			this.$emit('update:activeRoutes', updatedValue);
		},
		handleRoutesToggle() {
			if (this.activeRoutes.length == this.routeData.length) {
				this.$emit('update:activeRoutes', []);
			} else {
				this.$emit(
					'update:activeRoutes',
					this.routeData.map((route) => route.id)
				);
			}
		},
	},
};
</script>
